import * as React from 'react'
import { Flex } from '@radix-ui/themes'
import { Section } from '@/components/subscription/lp/section'
import { Modal } from '@/components/subscription/lp/modal'
import { styles } from './styles.css'
import mazzo from './images/mazzo.jpg'
import arrow from './images/arrow.svg'
import bubble from './images/bubble.svg'
import dialog1 from './images/dialog1.jpg'
import dialog2 from './images/dialog2.jpg'
import dialog3 from './images/dialog3.jpg'

export const VaseSection: React.FC = () => {
  return (
    <Section id="vase" title="FLOWER VASE" subtitle="ぴったりの花器もどうぞ！" className={styles.section}>
      <Flex direction="column" align="center" gap="24px" px="24px">
        <p className={styles.text}>フローリストが厳選！ちょうどいいサイズで使いやすいフラワーベース「mazzo」も一緒にご注文いただけます。</p>
        <div style={{ position: 'relative' }}>
          <img src={mazzo} className={styles.image} alt="人気No.1の花器「mazzo」" />
          <Modal
            title="フラワーベース「mazzo」について"
            renderTrigger={() => (
              <button className={styles.dialogButton} type="button">
                <Flex direction="row" align="center" gap="4px">
                  <span>詳しく見る</span>
                  <img src={arrow} />
                </Flex>
              </button>
            )}
            renderContent={() => (
              <Flex direction="column" align="center" justify="center" gap="24px" mb="40px" width="100%">
                <img src={dialog1} width="100%" />
                <p className={styles.dialogDescription}>
                  やわらかなくびれと、ぽってりとした安定感のある形。はじめて花器を買う人におすすめの「mazzo（マッツォ）」。一番の魅力はシンプルで飾る花を選ばないところ。頭の大きな花も、たっぷり小花を束ねたブーケもかわいくまとまる優れもの。
                  <br />
                  <br />
                  「ひとまずこの花器にいれておこう」ができる頼れる存在。そういう花器って実はなかなか出会えないかも？
                  <br />
                  <br />
                  サイズ：高さ20cm 直径8.5cm
                  <br />
                  素材：ガラス
                </p>
                <img src={dialog2} width="100%" />
                <p className={styles.dialogDescription}>
                  透明のガラスだから、水の状態がよく見えます。水が濁ると花の持ちも悪くなってしまうので、初めてさんにおすすめしやすいポイントのひとつ。
                </p>
                <img src={dialog3} width="100%" />
                <p className={styles.dialogDescription}>口が広いからお手入れも簡単。お花を長持ちさせるには花器を清潔に保つことが大切なんです。</p>
              </Flex>
            )}
          />
          <Flex direction="column" align="center" gap="8px" p="16px" className={styles.mazzo}>
            <img src={bubble} className={styles.bubble} />
            <Flex direction="column" align="center">
              <p className={styles.mazzoLine}>人気No.1の花器「mazzo」</p>
              <p className={styles.mazzoLine}>
                今ならプラス<span style={{ fontSize: '24px' }}>1,980</span>円で、お花と一緒にお届け
              </p>
            </Flex>
            <Flex direction="row" align="center" gap="8px">
              <span className={styles.mazzoPrice}>通常価格 2,400円</span>
              <span className={styles.mazzoLabel}>25%OFF</span>
            </Flex>
          </Flex>
        </div>
      </Flex>
    </Section>
  )
}
